const oemValuesMap = {
  iddero: {
    cloudDomain: "iddero.net",
    modelPrefix: "Iddero",
    modelNameMap: {
      VERIP: "VERSO+IP",
      VERIND: "VERSO INDOOR",
      VERIP2: "VERSO+IP 2",
      "SER3-KNX": "Home Server 3",
    },
    footerLink: "www.iddero.com",
    customAvatar: true,
    voiceControl: true,
    voiceCompatible: [
      "HC3-KNX",
      "HC3L-KNX",
      "SER3-KNX",
      "VERIND",
      "VERIP",
      "VERIP2",
    ],
  },
  eelectron: {
    cloudDomain: "eelectron.online",
    modelPrefix: "",
    modelNameMap: {
      VERIP: "TP43I11KNX",
      VERIND: "TP43I21KNX",
      VERIP2: "TP43M11KNX",
      "HC3-KNX": "TP70I12KNX",
      "HC3L-KNX": "TP10I12KNX",
    },
    footerLink: "www.eelectron.com",
    customAvatar: false,
    voiceControl: false,
    voiceCompatible: [],
  },
};

export const oemFlavor = process.env.REACT_APP_OEM_FLAVOR || "iddero";

export const oemValues = oemValuesMap[oemFlavor];
